/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import socket from '../../../common/store/socket';
import poll from '../../../common/store/poll';
import voter from '../../../common/store/voter';
import pollGroup from '../../../common/store/pollGroup';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules: {
    socket,
    poll,
    voter,
    pollGroup
  }
});
